import { __assign, __decorate, __extends, __rest } from "tslib";
import React from "react";
import { observer } from 'mobx-react';
import { Components, Utils } from '@singularsystems/neo-core';
import ComponentBase from './ComponentBase';
var Loader = /** @class */ (function (_super) {
    __extends(Loader, _super);
    function Loader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.overlayRef = React.createRef();
        _this.isShowing = false;
        _this.hasAnimated = false;
        return _this;
    }
    Loader.prototype.render = function () {
        var _a = this.props, show = _a.show, task = _a.task, showSpinner = _a.showSpinner, size = _a.size, native = __rest(_a, ["show", "task", "showSpinner", "size"]);
        show = show || (task && task.isBusy);
        var style = {};
        if (show) {
            if (!this.isShowing && (!task || !task.progressState.hasAnimated)) {
                // Start the fade animation the first time this renders
                this.isShowing = true;
                this.hasAnimated = false;
                if (task)
                    task.progressState.hasAnimated = true;
                style.opacity = 0;
            }
            else {
                style.opacity = 1;
            }
            style.display = "flex";
        }
        else {
            this.isShowing = false;
            style.display = "none";
        }
        native.className = Utils.joinWithSpaces("loader-container", native.className, size);
        var showInner = showSpinner !== false || (task && task.options.loadingText);
        return (React.createElement("div", __assign({}, native),
            this.props.children,
            React.createElement("div", { className: "loader-overlay", ref: this.overlayRef, style: style }, showInner && React.createElement("div", { className: "loader-inner" },
                showSpinner !== false && React.createElement("div", { className: "spinner-border" }),
                React.createElement("span", { className: "loader-text" }, task && task.options.loadingText)))));
    };
    Loader.prototype.afterRender = function () {
        if (this.overlayRef.current && !this.hasAnimated) {
            this.hasAnimated = true;
            Components.AnimationHelper.triggerReflow(this.overlayRef.current);
            this.overlayRef.current.style.opacity = "1";
        }
    };
    Loader = __decorate([
        observer
    ], Loader);
    return Loader;
}(ComponentBase));
export default Loader;
